export const listTheme = {
    byMaxHeight: {
        md: { maxHeight: '300px' },
        lg: { maxHeight: '420px' },
        none: { maxHeight: 'none' },
    },
};
export const popoverMaxHeightVariant = 
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => listTheme.byMaxHeight[props.maxHeight || 'none'];
